import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "var(--anv-bg)" }}
      data-testid="not-found-page"
    >
      <div className="anv-container max-w-xl text-center">
        <div className="anv-eyebrow">404</div>
        <h1 className="font-display mt-3 text-4xl md:text-5xl font-semibold text-[color:var(--anv-ink)]">
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-[color:var(--anv-muted)]">{t("notFound.description")}</p>
        <Link to="/" className="anv-btn-primary mt-8 inline-flex" data-testid="not-found-back">
          {t("notFound.back")}
        </Link>
      </div>
    </div>
  );
}
